import React from 'react';
import SwipeSlider from '@wix/da-shared-react/pkg/SwipeSlider';
import { withTranslation, WithTranslation } from 'react-i18next';
import { PapiDeviation } from '@wix/da-types-papi';
import { Url, USER_PROFILE_SHOP_SUB_PATHS } from '@wix/da-url';
import { MeasuredSlider as Slider } from '@wix/da-shared-react/pkg/Slider';
import { PANEL_HEIGHT } from '@wix/da-shared-react/pkg/DeviationViews/Thumb/Shop/ShopThumb';
import DuperbrowseContext from '../../../../../contexts/DuperbrowseContext';
import WidgetBox, {
  Props as WidgetBoxProps,
} from '../../../../UserWidgets/_partials/WidgetBox';
import { ShopItemType } from '../../../../../../types/shop';
import ShopThumb, {
  ShopThumbType,
} from '@wix/da-shared-react/pkg/DeviationViews/Thumb/Shop';
import EmptyState from '../../_partials/EmptyState';
import { withMobileContext } from '@wix/da-shared-react/pkg/Context/MobileContext';

export interface Props {
  streamId: string;
  moduleId: number;
  prints: PapiDeviation[];
  total: number;
  isOwner: boolean;
  username: string;
  isMobile?: boolean;
}

export class PrintsSlider extends React.Component<
  Props & WidgetBoxProps & WithTranslation
> {
  render() {
    const {
      t,
      streamId,
      widgetMoveUp,
      widgetMoveDown,
      widgetRemove,
      moduleId,
      prints,
      total,
      username,
      isMobile,
      section,
      zone,
    } = this.props;

    const isEmpty = !prints.length;

    return (
      <WidgetBox
        section={section}
        zone={zone}
        header={t!('common.prints_plural')}
        count={total}
        moduleId={moduleId}
        widgetMoveUp={widgetMoveUp}
        widgetMoveDown={widgetMoveDown}
        widgetRemove={widgetRemove}
        isEmpty={isEmpty}
        hasMore={!isEmpty} // until we implement inner slider overflow recognition
        emptyView={
          <EmptyState view="wide" shopItemType={ShopItemType.PRINTS} />
        }
        seeAllUrl={Url.userShopPath(
          username,
          USER_PROFILE_SHOP_SUB_PATHS.PRINTS
        )}
      >
        <DuperbrowseContext
          streamId={streamId}
          deviations={prints}
          parent={{ title: username }}
        >
          {isMobile ? (
            <SwipeSlider>
              {prints.map(print => (
                <ShopThumb
                  key={print.deviationId}
                  deviation={print}
                  type={ShopThumbType.PRINT}
                  showAuthor={false}
                />
              ))}
            </SwipeSlider>
          ) : (
            <Slider
              renderSliderItems={elementSize =>
                prints.map(print => (
                  <ShopThumb
                    key={print.deviationId}
                    deviation={print}
                    width={elementSize.width}
                    height={elementSize.height + PANEL_HEIGHT}
                    type={ShopThumbType.PRINT}
                    showAuthor={false}
                  />
                ))
              }
            />
          )}
        </DuperbrowseContext>
      </WidgetBox>
    );
  }
}

export default withMobileContext(withTranslation()(PrintsSlider));
